import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { MonitoredTrain } from '../../models/monitored-train';
import { ReferenceArea } from '../../../reference-areas/models/reference-area';
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subscription } from "rxjs";

type TableHeader = {
  header: string;
  width?: string;
}
@Component({
  selector: 'app-monitored-train-real-time-data',
  template: require('./monitored-train-real-time-data.component.html'),
  styles: [require('./monitored-train-real-time-data.component.sass')]
})
export class MonitoredTrainRealTimeDataComponent implements OnInit {

  @Input() currentTrain: MonitoredTrain;
  @Input() referenceAreas: ReferenceArea[];
  @Input() websocketCheckingTimer: Observable<number>; 

  gpsDataColumns: TableHeader[];
  marDataColumns: TableHeader[];
  boxDataColumns: TableHeader[];
  
  zoom: number = environment.config.map.trainInformation.defaultZoom
  speedMetric: string | undefined;


  languageChangeSubscription: Subscription;

  constructor(@Inject('$rootScope') $rootScope: any,
    private cd: ChangeDetectorRef,
    private translate: TranslateService) {
    $rootScope.$on('unitsChanged', (ev, value) => {
      this.speedMetric = value;
      this.cd.detectChanges();
    });
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.refreshTable();
    });
  }
  ngOnInit(): void {
    this.refreshTable();
  }

  ngOnChanges(changes: any) {
    console.log(changes)
  }
  refreshTable = () => {
      this._mar3InformationHeader();
      this._boxInformationHeader();
      this._gpsInformationHeader();
  }

  _mar3InformationHeader = () => {
    this.marDataColumns = [{
      header: this.translate.instant('I18N_MONITORING.LINK')
    }, {
      header: this.translate.instant('I18N_MONITORING.STATE')
    }, {
      header: this.translate.instant('I18N_MONITORING.BYTES_SENT')
    }, {
      header: this.translate.instant('I18N_MONITORING.BYTES_RECEIVED')
    }, {
      header: this.translate.instant('I18N_MONITORING.AVERAGE_LATENCY'),
      width: '100px'
    }, {
      header: this.translate.instant('I18N_MONITORING.UPLOAD_RATE'),
      width: '130px'
    }, {
      header: this.translate.instant('I18N_MONITORING.DOWNLOAD_RATE'),
      width: '130px'
    }, {
      header: this.translate.instant('I18N_MONITORING.SLOT'),
      width: '50px'
    }, {
      header: this.translate.instant('I18N_MONITORING.OPERATOR'),
      width: '200px'
    }, {
      header: this.translate.instant('I18N_MONITORING.CELL')
    }, {
      header: this.translate.instant('I18N_MONITORING.LAC')
    }, {
      header: this.translate.instant('I18N_MONITORING.NETWORK'),
      width: '130px'
    }, {
      header: this.translate.instant('I18N_MONITORING.BAND')
    }, {
      header: this.translate.instant('I18N_MONITORING.ICCID')
    }, {
      header: this.translate.instant('I18N_MONITORING.LAST_UPDATE')
    }]
  }

  _boxInformationHeader = () => {
    this.boxDataColumns = [{
      header: this.translate.instant('I18N_MONITORING.BOX')
    }, {
      header: this.translate.instant('I18N_MONITORING.SESSIONS')
    }, {
      header: this.translate.instant('I18N_MONITORING.STAFF_COUNT')
    }, {
      header: this.translate.instant('I18N_MONITORING.LOGINS')
    }, {
      header: this.translate.instant('I18N_MONITORING.LAST_UPDATE')
    }]
  }

  _gpsInformationHeader = () => {
    this.gpsDataColumns = [{
        header: this.translate.instant('I18N_MONITORING.VALID')
      }, {
        header: this.translate.instant('I18N_MONITORING.LATITUDE')
      },{
        header: this.translate.instant('I18N_MONITORING.LONGITUDE')
      },{
        header: this.translate.instant('I18N_MAP.TOOLTIP_ALTITUDE')
      },{
        header: this.translate.instant('I18N_MAP.TOOLTIP_HEADING')
      },{
        header: this.translate.instant('I18N_MONITORING.SPEED')
      },{
        header: this.translate.instant('I18N_MONITORING.LAST_UPDATE')
      }
    ]

  }
}
